import { Pipe, PipeTransform } from '@angular/core';

function select(item: any, selector: string): string {
  return selector ? item[selector] : item;
}

/**
 * A pipe that that shows a truncated list of elements, followed by a '(+n)' indicator.
 *
 * First parameter is the name of a property on the list elements,
 * for example for an array of Person objects: "people | etc:'firstName'",
 * or skip the propertyName to use the items as-is, for example: "names | etc".
 *
 * Second parameter is how many items to iterate before showing the '(+n)' indicator,
 * or -1 to include all items. (Default: 1)
 *
 * Third parameter is the separator between items. (Default: ', ')
 */
@Pipe({
    name: 'etc',
    standalone: false
})
export class EtcPipe implements PipeTransform {
  transform(value: any, propertyName: string, count: number = 1, separator: string = ', ') {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        count = count > value.length ? value.length : count > 0 ? count : count === -1 ? value.length : 1;
        let text = select(value[0], propertyName);
        for (let i = 1; i < count; ++i) {
          let item = select(value[i], propertyName);
          text += `${separator}${item}`;
        }
        if (value.length > count) {
          text += ` (+${value.length - count})`;
        }
        return text;
      }
    } else if (value) {
      return value;
    } else if (value === 0) {
      return '0';
    }
    return '';
  }
}
